import React, {useCallback, useEffect} from 'react';
import {useHistory} from "react-router-dom";
import Highcharts from 'highcharts';
import {Box, Button, CircularProgress, Grid, makeStyles} from '@material-ui/core';
import HighchartsReact from 'highcharts-react-official';
import UtilService from "../../../../../helper/service";
import roles from "../../../../../helper/roles";
import CSVReader from "react-csv-reader";
import clsx from "clsx";
import {useDispatch, useSelector} from "react-redux";
import {getManageHubs} from "../../../../../store/actions/creator/creatorExperienceManager";
import {Mixpanel} from "../../../../../helper/mixpanel";

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
  cardSection: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '24px'
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  header: {
    fontFamily: 'roboto-bold',
    fontSize: '20px',
    letterSpacing: 0,
    marginBottom: 20,
    marginTop: 0,
    color: '#212D40',
    '@media screen and (max-width: 500px)': {
      fontSize: '16px'
    }
  },
  label: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    letterSpacing: 0.21,
    marginTop: 0,
    textAlign: 'center',
    margin: 0,
    '@media (max-width: 1251px)': {
      fontSize: 12
    }
  },
  totalParticipantsCount: {
    fontFamily: 'roboto-bold',
    fontSize: '28px',
    color: '#212D40',
    letterSpacing: 0,
    marginBottom: 0,
    marginTop: 0,
    textAlign: 'center',
  },
  participantsLabel: {
    fontFamily: 'roboto-regular',
    fontSize: '12px',
    color: '#212D40',
    marginTop: 0,
    textAlign: 'center',
    margin: 0
  },
  number: {
    textAlign: 'center',
    fontFamily: 'roboto-bold',
    fontSize: 32,
    letterSpacing: 0,
    marginBottom: 0,
    marginTop: 0,
    '@media (max-width: 1251px)': {
      fontSize: 30
    }
  },
  completed: {
    minWidth: 70,
    maxWidth: 90,
    marginRight: 35,
    color: '#017AEF',
    borderBottom: '3px solid #017AEF',
    paddingBottom: '6px',
    '@media (max-width: 670px)': {
      marginRight: 10
    }
  },
  progress: {
    minWidth: 70,
    maxWidth: 90,
    marginRight: 35,
    color: '#017AEF50',
    borderBottom: '3px solid #017AEF80',
    paddingBottom: '6px',
    '@media (max-width: 670px)': {
      marginRight: 10
    }
  },
  notstarted: {
    minWidth: 70,
    maxWidth: 90,
    marginRight: 35,
    color: '#697683',
    borderBottom: '3px solid #697683',
    paddingBottom: '6px',
    '@media (max-width: 670px)': {
      marginRight: 10
    }
  },
  error: {
    minWidth: 70,
    maxWidth: 90,
    color: '#ED564A',
    borderBottom: '3px solid #ED564A',
    paddingBottom: '6px'
  },
  centerLabel: {
    position: 'absolute',
    top: 37,
    left: 43
  },
  actionBtnDiv: {
    position: 'absolute',
    right: 0,
    float:'right'
  },
  manageHubBtn: {
    textTransform: 'none',
    borderRadius: 6,
    boxShadow: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    marginRight: 10,
    '& span': {
      '@media (min-width: 900px)': {
        minWidth: '111px!important'
      }
    }
  },
  addpartbtn: {
    textTransform: 'none',
    borderRadius: 6,
    boxShadow: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    '& span': {
      '@media (min-width: 900px)': {
        minWidth: '111px!important'
      }
    }
  },
  csvBtn: {
    textTransform: 'none',
    width: 100,
    height: 37,
    borderRadius: 6,
    backgroundColor: '#F0F0F0',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    right: 0,
    '& input': {
      display: 'none'
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#d5d5d5',
      boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    },
  },
  csvLabel: {
    cursor: 'pointer',
    padding: 8
  },
  mainDiv: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '571px'
  },
  topPanel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  bottomPanel: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between'
  },
  statusRightPanel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
})
);

interface IProps {
  session: any,
  session_code: string,
  showCollapseMenu: boolean,
  isMobile: boolean,
  importCSV: (data: any, fileInfo: any) => void
}

export default function ParticipantStatus(props: IProps) {
  const classes = useStyles();
  const { session, session_code, showCollapseMenu, isMobile, importCSV } = props;
  const old_participants = useSelector((state: any) => state.experience.participants);
  const new_participants = useSelector((state: any) => state.liveParticipants.liveParticipants);
  const participants = new_participants ? new_participants : old_participants;
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};

  const history = useHistory();
  const dispatch = useDispatch();
  const { managerHubList } = useSelector((state: any) => state.creatorExperienceManager);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [randomID, setRendomId] = React.useState(1);
  const [chatopts, handleChartOpts] = React.useState<any[]>([]);
  const parseOptions = {
    header: false,
    skipEmptyLines: true
  };

  const participantStatus = participants?.participant_status;
  const completed = participantStatus?.completed || 0;
  const in_progress = participantStatus?.in_progress || 0;
  const not_started = participantStatus?.not_started || 0;
  const error = participantStatus?.error || 0;

  const options = [
    ["Completed", completed || 0],
    ["In Progress", in_progress || 0],
    ["Not Started", not_started || 0],
    ["Error", error || 0]
  ];

  useEffect(() => {
    handleChartOpts(options);
  }, []);

  const onManageHubs = useCallback(() => {
    if (session && session['session_id']) {
      const request: any = {session_id: Number(session['session_id'])};
      if (loginUserData.department_id) {
        request['department_id'] = Number(loginUserData.department_id)
      }
      dispatch(getManageHubs(apolloClient.client, request));
      let url = `/creator/experience-manager/manage-hubs`;
      if (!!loginUserData) {
        if (UtilService.checkTrialAccess(loginUserData, roles['trial']['experiences'])) {
          url = `/subscriber/creator/experience-manager/manage-hubs`;
        }
      }
      history.push(url, { session_id: session['session_id'] });
    }
  }, [session]);

  const handleAddParticipants = () => {
    let url = `/creator/experience-manager/invite/${session_code}`;
    if (!!loginUserData) {
      if (UtilService.checkTrialAccess(loginUserData, roles['trial']['experiences'])) {
        url = `/subscriber/creator/experience-manager/invite/${session_code}`;
      }
    }
    history.push(url);
  };
  
  const handleForceCSV = (data: any, fileInfo: any) => {
    Mixpanel.identify(loginUserData.user_id);
    Mixpanel.track('import_tags', {
      'Experience Type': `${session.session_type}`,
      'Experience Owner': `${session.user.first_name} ${session.user.last_name}`
    });
    Mixpanel.people.set({
      $email: loginUserData.username,
      $first_name: loginUserData.first_name,
      $last_name: loginUserData.last_name,
      $team: loginUserData.department_name,
      $type: loginUserData.role_alias
    });

    importCSV(data, fileInfo);
    setRendomId(randomID + 1)
  };

  return (
    <div className={clsx('card', classes.cardSection)}>
      {!participantStatus && (
        <div className={classes.loading}><CircularProgress /></div>
      )}
      {participantStatus && (
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" style={{ width: '100%', position: 'relative' }}>
          {isMobile ? (
            <Grid container>
              <Grid item xs={12}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <div style={{ height: '140px', position: 'relative' }}>
                    <HighchartsReact
                      containerProps={{ style: { width: '150px', height: '100%' } }}
                      highcharts={Highcharts}
                      options={{
                        chart: {
                          renderTo: 'container',
                          type: 'pie'
                        },
                        title: {
                          text: ''
                        },
                        yAxis: {
                          title: {
                            text: 'Total percent market share'
                          }
                        },
                        credits: {
                          enabled: false
                        },
                        series: [{
                          name: '',
                          data: chatopts,
                          colors: ['#017AEF', '#017AEF80', '#697683', '#ED564A'],
                          size: '130%',
                          innerSize: '85%',
                          dataLabels: {
                            enabled: false
                          }
                        }],
                      }}
                    />
                    <div className={classes.centerLabel}>
                      <p className={classes.totalParticipantsCount}>{participantStatus.total}</p>
                      <p className={classes.participantsLabel}>Participants</p>
                    </div>
                  </div>
                  <div className={classes.header}>Measurement Status</div>
                </div>
              </Grid>
              <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around' }}>
                <div className={classes.completed}>
                  <p className={classes.number}>{participantStatus.completed}</p>
                  <p className={classes.label}>Completed</p>
                </div>
                <div className={classes.progress}>
                  <p className={classes.number}>{participantStatus.in_progress}</p>
                  <p className={classes.label}>In Progress</p>
                </div>
              </Grid>
              <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', marginTop: 10 }}>
                <div className={classes.notstarted}>
                  <p className={classes.number}>{participantStatus.not_started}</p>
                  <p className={classes.label}>Not Started</p>
                </div>
                <div className={classes.error}>
                  <p className={classes.number}>{participantStatus.error}</p>
                  <p className={classes.label}>Removed</p>
                </div>
              </Grid>
            </Grid>
          ) : (
            <div className={classes.mainDiv}>
              <div className={classes.topPanel}>
                <div className={classes.header}>Measurement Status</div>
                {(!showCollapseMenu && session['session_status'] !== 'COMPLETED') && (
                  <div className={classes.actionBtnDiv}>
                    {(managerHubList.length > 0 && session['using_hub_connectivity']) && <Button variant="contained" classes={{ root: classes.manageHubBtn }} onClick={onManageHubs}>Manage Hubs</Button>}
                    <Button variant="contained" classes={{ root: classes.addpartbtn }} onClick={handleAddParticipants}>Add Participants</Button>
                  </div>
                )}
                {(!showCollapseMenu && session['session_status'] === 'COMPLETED') && (
                  <CSVReader
                    key={randomID}
                    cssClass={classes.csvBtn}
                    cssLabelClass={classes.csvLabel}
                    label="Import Tags"
                    onFileLoaded={(data, fileInfo) => handleForceCSV(data, fileInfo)}
                    parserOptions={parseOptions}
                  />
                )}
              </div>
              <div className={classes.bottomPanel}>
                <div style={{ height: '140px', position: 'relative' }}>
                  <HighchartsReact
                    containerProps={{ style: { width: '150px', height: '100%' } }}
                    highcharts={Highcharts}
                    options={{
                      chart: {
                        renderTo: 'container',
                        type: 'pie'
                      },
                      title: {
                        text: ''
                      },
                      yAxis: {
                        title: {
                          text: 'Total percent market share'
                        }
                      },
                      credits: {
                        enabled: false
                      },
                      series: [{
                        name: '',
                        data: chatopts,
                        colors: ['#017AEF', '#017AEF80', '#697683', '#ED564A'],
                        size: '130%',
                        innerSize: '85%',
                        dataLabels: {
                          enabled: false
                        }
                      }],
                    }}
                  />
                  <div className={classes.centerLabel}>
                    <p className={classes.totalParticipantsCount}>{participantStatus.total}</p>
                    <p className={classes.participantsLabel}>Participants</p>
                  </div>
                </div>
                <div className={classes.statusRightPanel}>
                  <div className={classes.completed}>
                    <p className={classes.number}>{participantStatus.completed}</p>
                    <p className={classes.label}>Completed</p>
                  </div>
                  <div className={classes.progress}>
                    <p className={classes.number}>{participantStatus.in_progress}</p>
                    <p className={classes.label}>In Progress</p>
                  </div>
                  <div className={classes.notstarted}>
                    <p className={classes.number}>{participantStatus.not_started}</p>
                    <p className={classes.label}>Not Started</p>
                  </div>
                  <div className={classes.error}>
                    <p className={classes.number}>{participantStatus.error}</p>
                    <p className={classes.label}>Removed</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Box>
      )}
    </div>
  );
}